/**
 * Keeps <meta name="theme-color"> (browser chrome, PWA and WKWebView status
 * area) on the page background of the theme actually in use. The theme is the
 * `dark` class set from localStorage, not prefers-color-scheme, so index.html's
 * media-query tags are only a first-paint fallback and are replaced here.
 */
const LIGHT = "#FBFAF7";
const DARK = "#0B1220";

export function syncThemeColor(doc: Document = document): void {
  const color = doc.documentElement.classList.contains("dark") ? DARK : LIGHT;
  doc.querySelectorAll('meta[name="theme-color"]').forEach((m) => m.remove());
  const meta = doc.createElement("meta");
  meta.name = "theme-color";
  meta.content = color;
  doc.head.appendChild(meta);
}
